import axios from "axios";

const BASE_URL =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_ENDPOINT_URL
    : process.env.REACT_APP_ENDPOINT_URL_ONLINE;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
});

export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

// Request interceptor to add Authorization header with token from localStorage
axiosPrivate.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken"); // Adjust as per your token storage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const axiosJose = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/jose" },
});

export default axiosInstance;
